import(/* webpackMode: "eager" */ "/Users/mac/Desktop/southchip/official/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CookiePolicy"] */ "/Users/mac/Desktop/southchip/official/src/components/blocks/SiteConfig/CodeSnippet.tsx");
